import { lazy } from 'react';
import MissionDetails from './components/Missions/MissionDetails';
import PreviewPayloads from './components/Missions/StepperComponents/CommonSteperComponents/Payloads/PreviewPayload';
import EdgePreview from './components/Missions/StepperComponents/CommonSteperComponents/Edge/EdgePreview';
import Edge from './components/Missions/StepperComponents/CommonSteperComponents/Edge/Edge';
import SelectTemplate from './components/Missions/StepperComponents/CommonSteperComponents/Template/SelectTemplate';
import Payloads from './components/Missions/StepperComponents/CommonSteperComponents/Payloads/Payloads';
import ReviewBuild from './components/Missions/StepperComponents/CommonSteperComponents/ReviewBuild';
import SimulateDetails from './components/simulate/SimulateDetails';
import Bus from './components/Missions/StepperComponents/CommonSteperComponents/Bus/Bus';
import Operate from './components/Missions/Operate/Operate';
import User from './components/Missions/AdminPanel/User';
import Scenario from './components/simulate/my-scenario/Scenario';
import GroundStationsDetails from './components/Missions/GroundStationsAndProviders/GroundStationsDetails/GroundStationsDetails';
import GSProviderDetails from './components/Missions/GroundStationsAndProviders/GSProviderDetails/GSProviderDetails';
import CommunicationDetails from './components/Missions/Satellites/Communication/CommunicationDetails/CommunicationDetails';
import CommandCenterDashboard from './components/command_center/CommandCenterDashboard';
import UnifiedControlPlane from './components/UnifiedControlPlane/UnifiedControlPlane';
import Catalogs from './components/catalogs/Catalogs';
import MissionConfigNew from './components/Missions/MissionConfigNew';
import Create3DSat from './components/Missions/Satellites/SatelliteProfile/SatelliteDesigner/Create3DSat';
import Modelling from './components/modelling/Modelling';
import ModellingV2 from './components/mission_modelling_v2/Modelling';
import GenericSimulatorDashboard from './components/GenericSimulator/GenericSimulatorDashboard';
import ValidateDetails from './components/validate/details/ValidateDetails';
import TestCaseDetail from './components/Missions/Satellites/TestCase/TestCaseDetail';
const Missions = lazy(() => import('./components/Missions/Missions'));
const SatelliteDetails = lazy(() => import('./components/Missions/Satellites/SatelliteDetails'));
const PayloadDetails = lazy(() => import('./components/Missions/Satellites/PayloadDetails'));

interface RoutesType {
  url: string,
  component: any,
  id: string,
}

const RouterUrl: RoutesType[] = [

  {
    url: '/user/:user_name/:user_id',
    component: User,
    id: 'user',
  },
  {
    url: '/',
    component: Missions,
    id: 'mission',
  },

  {
    url: '/:project_name/edit_mission/:mission_name/:mission_id',
    component: MissionConfigNew,
    id: 'edit_mission',
  },

  {
    url: '/:project_name/:project_id/create_mission',
    component: MissionConfigNew,
    id: 'create_mission',
  },

  {
    url: '/:mission_name/_details/:mission_id/:tab_name',
    component: MissionDetails,
    id: 'mission_details',
  },


  {
    url: '/:mission_name/:mission_id/:sat_id/add_new_payload',
    component: Payloads,
    id: 'add_new_payload',
  }, {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/preview_payload',
    component: PreviewPayloads,
    id: 'preview_payload',
  }, {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/edit_payload/:payload_name/:payload_id',
    component: Payloads,
    id: 'edit_payload',
  },

  {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/add_new_edge',
    component: Edge,
    id: 'add_new_edge',
  }, {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/preview_edge',
    component: EdgePreview,
    id: 'preview_edge',
  }, {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/edit_edge/:edge_name/:edge_id',
    component: Edge,
    id: 'edit_edge',
  },

  {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/add_new_template',
    component: SelectTemplate,
    id: 'add_new_template',
  }, {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/edit_template/:template_name/:template_id',
    component: SelectTemplate,
    id: 'edit_template',
  },

  {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/review_satellite',
    component: ReviewBuild,
    id: 'review_satellite',
  },

  {
    url: '/:mission_name/:mission_id/view_satellite/:sat_name/:sat_id/:type',
    component: Bus,
    id: 'bus',
  },
  {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/:type/:bus_name/:bus_id',
    component: Bus,
    id: 'create_bus',
  },

  {
    url: '/:mission_name/:mission_id/sat_details/:sat_name/:sat_id/:tab_name',
    component: SatelliteDetails,
    id: 'satelliteDetails',
  },
  {
    url: '/:mission_name/:mission_id/:sat_name/:sat_id/template/:template_id/communication/:device_id/:tab_name',
    component: CommunicationDetails,
    id: 'communication_details',
  },

  {
    url: `/:mission_name/:mission_id/:sat_name/:sat_id/payload_details/:pay_name/:payload_id/:type`,
    component: PayloadDetails,
    id: 'payloadDetails',
  },

  {
    url: '/:mission_name/:mission_id/simulate',
    component: SimulateDetails,
    id: 'simulate',
  },
  {
    url: '/:mission_name/:mission_id/validate',
    component: ValidateDetails,
    id: 'validate',
  },
  {
    url: "/:mission_name/:mission_id/:dashboard/:scenario_id/satGroupId/:sat_grp_id/satellite/:sat_id/:tab_name",
    component: CommandCenterDashboard,
    id: 'command_center',
  },

  {
    url: "/:mission_name/:mission_id/:dashboard/:scenario_id/generic_simulator",
    component: GenericSimulatorDashboard,
    id: 'manual',
  },

  {
    url: '/:mission_name/:mission_id/operate-dashboard',
    component: Operate,
    id: 'operate-dashboard',
  },
  {
    url: '/mission/:mission_name/:mission_id/scenario',
    component: Scenario,
    id: 'create_new_scenario',
  },

  {
    url: '/:mission_name/:mission_id/ground_station/:station_name/:station_id',
    component: GroundStationsDetails,
    id: 'ground_station',
  },

  {
    url: '/:mission_name/:mission_id/station_provider/:provider_name/:provider_id/:tab_name',
    component: GSProviderDetails,
    id: 'station_provider',
  },
  {
    url: '/mission/:mission_id/modeling/:scenario_id',
    component: ModellingV2,
    id: 'modeling',
  },
  {
    url: "/:mission_name/:mission_id/collect",
    component: UnifiedControlPlane,
    id: "unifiedControlPlane",
  },
  {
    url: "/:mission_name/:mission_id/catalogs",
    component: Catalogs,
    id: "catalogs",
  },

  {
    // url: "/:mission_name/:mission_id/view_satellite/:sat_name/:sat_id/satellite_designer",
    url: "/:mission_name/:mission_id/:sat_name/:sat_id/view_satellite/satellite_designer",
    component: Create3DSat,
    id: "satellite_designer_sensor_placement",
  },

  {
    url: '/:mission_name/:mission_id/sat_details/:sat_name/:sat_id/test_case/:test_case_name/:test_case_id',
    component: TestCaseDetail,
    id: 'test_case_detail',
  },

];

export { RouterUrl };
